import Vue from 'vue';
import { defaultSupervisorSummaryTableSettings } from '.';

const isOfflineModeEnabled = state => {
  return state.connectionSettings ? state.connectionSettings.offlineMode : false;
};

const preferencesSettings = (state, getters) => {
  return getters.currentUserSettings.preferencesSettings;
};

const applicationSettings = (state, getters) => {
  return getters.currentUserSettings.applicationSettings;
};

const userSoftPhoneSettings = state => {
  return state.softPhoneSettings;
};

const agentSettings = (state, getters) => {
  return getters.currentUserSettings.agentSettings;
};

const agentStateSettings = (state, getters) => {
  return getters.currentUserSettings.agentStateSettings;
};

const featuresSettings = (state, getters) => {
  return getters.currentUserSettings.featuresSettings;
};

const dashboardSettings = (state, getters) => {
  return getters.currentUserSettings.dashboardSettings;
};

const supervisorDashboardSettings = (state, getters) => {
  return getters.currentUserSettings.supervisorDashboardSettings;
};

const supervisorWallboardSettings = (state, getters) => {
  return getters.currentUserSettings.supervisorWallboardSettings;
};

const lastUserSettingsUpdate = (state, getters) => {
  return getters.lastUserSettingsUpdate;
};

const currentUserSettings = state => {
  return Vue.observable(structuredClone(state.currentUserSettings));
};

const incomingInteractionCallRingtone = (state, getters, rootState, rootGetters) => {
  const callRingtone = getters.currentUserSettings.preferencesSettings.incomingInteractionRingtones.call;
  return rootGetters['REFERENCES/availableIncomingInteractionRingtones'].find(
    ringtone => ringtone.value === callRingtone
  );
};

const incomingInteractionChatRingtone = (state, getters, rootState, rootGetters) => {
  const chatRingtone = getters.currentUserSettings.preferencesSettings.incomingInteractionRingtones.chat;
  return rootGetters['REFERENCES/availableIncomingInteractionRingtones'].find(
    ringtone => ringtone.value === chatRingtone
  );
};

const incomingInteractionEmailRingtone = (state, getters, rootState, rootGetters) => {
  const emailRingtone = getters.currentUserSettings.preferencesSettings.incomingInteractionRingtones.email;
  return rootGetters['REFERENCES/availableIncomingInteractionRingtones'].find(
    ringtone => ringtone.value === emailRingtone
  );
};

const incomingInteractionSmsRingtone = (state, getters, rootState, rootGetters) => {
  const smsRingtone = getters.currentUserSettings.preferencesSettings.incomingInteractionRingtones.sms;
  return rootGetters['REFERENCES/availableIncomingInteractionRingtones'].find(
    ringtone => ringtone.value === smsRingtone
  );
};

const supervisorSummaryTable = (state, getters) => {
  return getters.currentUserSettings.supervisorDashboardSettings.summaryTable;
};

const supervisorSummaryTableSettings = (state, getters) => {
  const supervisorDashboardSettings = getters.currentUserSettings.supervisorDashboardSettings;
  return supervisorDashboardSettings.summaryTableSettings || defaultSupervisorSummaryTableSettings;
};

export default {
  currentUserSettings,
  preferencesSettings,
  applicationSettings,
  userSoftPhoneSettings,
  agentSettings,
  agentStateSettings,
  featuresSettings,
  dashboardSettings,
  lastUserSettingsUpdate,
  supervisorDashboardSettings,
  supervisorWallboardSettings,
  isOfflineModeEnabled,
  incomingInteractionCallRingtone,
  incomingInteractionChatRingtone,
  incomingInteractionEmailRingtone,
  incomingInteractionSmsRingtone,
  supervisorSummaryTable,
  supervisorSummaryTableSettings
};
